// Footer.tsx
import React from "react";
import { FooterContainer, LogoFooter, TextFooter } from "./styles";
import "./footer.scss";

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <LogoFooter src={require("../../assets/logo-Santa-Casa-Cunha.webp")} />
      <TextFooter>
        © {new Date().getFullYear()} Santa Casa de Cunha - Todos os direitos
        reservados
      </TextFooter>
    </FooterContainer>
  );
};

export default Footer;
